module.exports = __webpack_public_path__ + "img/qrcode.logo.border.a4b47677.svg";